import { graphql } from 'relay-runtime';

export const PreConfiguredSourcesQuery = graphql`
  query preconfiguredSourcesQuery {
    preconfiguredSources {
      name
      provider
      displayName
      stableVersion
      configuration {
        type
        fields {
          secretName
          envVarName
          description
          required
          visible
          hint
          type
          order
          options
        }
      }
    }
  }
`.default;
